import { useAdminPasswordUpdate } from "../../../hooks/api/user/hooks";
import { Button, Form, Input, message } from "antd";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object({
  currentPassword: yup
    .string()
    .required("Current password is required")
    .min(5, "Must be at least 6 characters"),

  newPassword: yup
    .string()
    .required("New password is required")
    .min(5, "Must be at least 6 characters"),

  confirmPassword: yup
    .string()
    .required("Please confirm password")
    .oneOf([yup.ref("newPassword")], "Passwords do not match"),
});

type PasswordFormType = yup.InferType<typeof schema>;

const SecurityForm = () => {
  const [messageApi, contextHolder] = message.useMessage();

  const { mutate: updatePassword, isPending } = useAdminPasswordUpdate({
    onSuccess: () => {
      messageApi.success("Password updated successfully");
      reset();
    },
    onError: (err: any) => {
      messageApi.error(err?.message || "Something went wrong");
    },
  });

  const {
    control,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm<PasswordFormType>({
    resolver: yupResolver(schema),
  });

  const onSubmit = (values: PasswordFormType) => {
    if (values.currentPassword === values.newPassword) {
      messageApi.error("New password cannot be same as current password");
      return;
    }

    updatePassword({
      old_password: values.currentPassword,
      password: values.newPassword,
      confirm_password: values.confirmPassword,
    });
  };

  return (
    <div>
      {contextHolder}

      <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
        <div className="bg-[#fbeee3] p-6 rounded-xl">

          {/* Current Password */}
          <Form.Item
            label="Current Password"
            validateStatus={errors.currentPassword ? "error" : ""}
            help={errors.currentPassword?.message}
          >
            <Controller
              name="currentPassword"
              control={control}
              render={({ field }) => (
                <Input.Password {...field} placeholder="Enter current password" />
              )}
            />
          </Form.Item>

          {/* New Password */}
          <Form.Item
            label="New Password"
            validateStatus={errors.newPassword ? "error" : ""}
            help={errors.newPassword?.message}
          >
            <Controller
              name="newPassword"
              control={control}
              render={({ field }) => (
                <Input.Password {...field} placeholder="Enter new password" />
              )}
            />
          </Form.Item>

          {/* Confirm Password */}
          <Form.Item
            label="Re-enter New Password"
            validateStatus={errors.confirmPassword ? "error" : ""}
            help={errors.confirmPassword?.message}
          >
            <Controller
              name="confirmPassword"
              control={control}
              render={({ field }) => (
                <Input.Password {...field} placeholder="Confirm password" />
              )}
            />
          </Form.Item>
        </div>

        <div className="flex gap-3 mt-5">
          <Button
            type="primary"
            className="px-10"
            loading={isPending}
            htmlType="submit"
            disabled={isPending}
          >
            Save
          </Button>

     
        </div>
      </Form>
    </div>
  );
};

export default SecurityForm;
